import AccessType from 'constants/customerAccessType';
import nxModule from 'nxModule';
import LocalCache from 'shared/utils/localCache';

nxModule.factory('groupCustomerCache', function (http, activeCustomerService, cacheAccessService, CacheFactory) {
  let that = this;
  let service = {};

  service.loadedCustomerId = null;

  that.cacheMap = {};

  service.profile = (customerId) =>
    retrieveCacheObject(customerId, 'profile', {
      provider: () => http.get(`/customers/${customerId}`)
        .success(profile => {
          if (profile.customerType !== 'GROUP')
            console.error(`ERROR: loaded non-group customer. customerId: ${customerId}`);

          if (!profile.customerGroup.customers) {
            profile.customerGroup.customers = [];
          }
        })
    });

  service.individualLoans = (customerId) =>
    retrieveCacheObject(customerId, 'customerIndividualLoan', {
      provider: () => http.get(`/products/loans/group-customer/${customerId}`)
    });

  service.groupLoans = (customerId) =>
    retrieveCacheObject(customerId, 'customerGroupLoan', {
      provider: () => http.get(`/products/loans/group-loan/customer/${customerId}`)
    });

  /**
   * fullAccess equals false means that stream of data from cache will contain
   * only products that current user has access to.
   */
  service.batch = (customerId, fullAccess=true) => {
    const url = `/products/loans/batch/${customerId}`;
    const cache = retrieveCacheObject(customerId, 'customerBatch', {
      provider: () => http.get(url)
    });

    if(fullAccess) {
      return cache;
    }

    return cacheAccessService.withRestrictedAccess(cache, customerId, AccessType.GROUP,
      (response, branchId) => {
        return response.filter(batch => batch.loans.every(loan => loan.branchId === branchId))
      });
  };


  // --------- technical functions -------------
  function retrieveCacheObject(customerId, cacheName, cacheOptions) {
    verifyCustomerId(customerId);

    // adds default params
    cacheOptions['cacheStorage'] = 'memory';
    cacheOptions['cacheName'] = `${cacheName}-group-${customerId}`;
    cacheOptions['cacheFactory'] = CacheFactory;

    if (!that.cacheMap[cacheName]) {
      that.cacheMap[cacheName] = new LocalCache(cacheOptions);
    }
    return that.cacheMap[cacheName];
  }

  service.refetch = () => {
    let keys = Object.keys(that.cacheMap);
    for (let key of keys) {
      console.log('Refetching group customer data: ' + key);
      that.cacheMap[key].refetch();
    }
  };

  service.evict = () => {
    service.loadedCustomerId = null;
    activeCustomerService.ofType(AccessType.GROUP).updateCustomerId(null);
    resetCacheMap();
  };

  service.evictWithoutCustomerId = () => {
    resetCacheMap();
  };

  service.unloadCustomer = () => {
    service.loadedCustomerId = null;
    activeCustomerService.ofType(AccessType.GROUP).updateCustomerId(null);
    service.evict();
  };

  const resetCacheMap = () => {
    const keys = Object.keys(that.cacheMap);
    for (const key of keys) {
      that.cacheMap[key].evict();
    }
    that.cacheMap = {};
  }

  function verifyCustomerId(newCustomerId) {
    if (service.loadedCustomerId && String(service.loadedCustomerId) !== String(newCustomerId)) {
      resetCacheMap();
    }
    service.loadedCustomerId = newCustomerId;
    activeCustomerService.ofType(AccessType.GROUP).updateCustomerId(newCustomerId);
  }

  return service;
});
